<template>
  <a-config-provider :locale="zhCN">
    <div class="app-container">
      <HeaderNav class="header-nav" />
      <div class="main-area">
        <div class="sidebar-section" :style="{ width: sidebarCollapsed ? '80px' : '220px' }">
          <SideMenu :collapsed="sidebarCollapsed" />
        </div>
        <Breadcrumb :collapsed="sidebarCollapsed" @toggle-collapsed="toggleSidebar" />
        <div class="content-section" :key="contentKey">
          <div class="content-wrapper">
            <router-view />
            <transition name="fade">
              <div v-if="isLoading" class="loading-overlay">
                <div class="loading-content">
                  <div class="loading-spinner">
                  <a-icon type="loading" style="font-size: 48px;" />
                </div>
                  <div class="loading-text">{{ loadingText }}</div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </a-config-provider>
</template>

<script>
import HeaderNav from './components/HeaderNav.vue'
import SideMenu from './components/SideMenu.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'App',
  components: {
    HeaderNav,
    SideMenu,
    Breadcrumb
  },
  data() {
    return {
      contentKey: Date.now(),
      zhCN,
      sidebarCollapsed: false
    }
  },
  computed: {
    isLoading() {
      return this.$loading().isLoading()
    },
    loadingText() {
      return this.$loading().loadingText()
    }
  },
  provide() {
    return {
      refreshContent: this.refreshContent
    }
  },
  methods: {
    refreshContent() {
      this.$loading().showLoading('加载中...')
      setTimeout(() => {
        this.contentKey = Date.now()
        setTimeout(() => {
          this.$loading().hideLoading()
        }, 300)
      }, 500)
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    }
  }
}
</script>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: #ebedef;
  position: relative;
  overflow: hidden;
}

.header-nav {
  position: relative;
  z-index: 40;
  flex-shrink: 0;
  width: 100%;
}

.main-area {
  flex: 1;
  position: relative;
  display: flex;
  overflow: hidden;
}

.sidebar-section {
  flex-shrink: 0;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  z-index: 30;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s ease;
}

.content-section {
  flex: 1;
  background: #EBEDEF;
  z-index: 10;
  padding: 16px;
  padding-top: 64px; /* 16px + 48px for breadcrumb */
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
  width: 0; /* ✅ 防止内容区被挤出去 */
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #ffffff;
  border-radius: 4px;
  overflow-y: auto;
  box-sizing: border-box;
  min-height: 0;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-spinner {
  font-size: 48px;
  color: #fc6732;
}

.loading-text {
  font-size: 14px;
  color: #5e5e66;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimHei, Arial, Helvetica, sans-serif;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>